import React, { useState } from "react";

import {
    Box,
    Paper,
    Divider,
    TextField,
    Stack,
    IconButton,
    Grid,
    Typography,
    Switch,
    FormControlLabel,
    FormControl,
    InputLabel,
    Select,
    Card,
    MenuItem,
    ListItemText,
    FormHelperText,
    styled,
    FormGroup,
    Checkbox,
    Button
} from '@mui/material';

import { LoadingButton } from '@mui/lab';
import { useNavigate } from "react-router-dom"
import { useFormik } from 'formik';

import CommonBreadcumbs from '../common/CommonBreadcumbs';
import CommonSectionHeader from "../common/CommonSectionHeader";
import CommonRestricted from '../common/CommonRestricted';

import { useSystemRoutes, routeTypes } from '../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../hooks/useSystemHead';

import {
    useInjectionFields,
    injectionFieldTypes,
    moduleTypes,
    fieldDataTypes,
    moduleReferences,
} from '../../hooks/api/useInjectionFields';

import { useSystemPrompt } from "../../hooks/useSystemPrompt";
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../hooks/usePermissions';
import { useTranslations } from "../../hooks/useTranslations";

import {
    initialValues,
    validationSchema,
} from "../../schema/injectionFields/injectionFieldSchema";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3)
}));

export default function NewInjectionField({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@injectionProp", "@injectionField", "prompt"] })

    const { promptMessage } = useSystemPrompt();
    const { isLoading, create } = useInjectionFields({ injectionFieldType: injectionFieldTypes.injectionFields });
    const navigate = useNavigate();
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.customField.id, scopeTypes.customField.customField.id)

    // const [inputType, setInputType] = useState("")

    const onSubmit = async (currentValues) => {

        console.log('currentValues', currentValues)

        try {

            let _targetType = 'injection_field'

            // Object.keys(fieldTypes).forEach(i => {
            //     Object.keys(fieldTypes[i]).forEach(i2 => {
            //         if (fieldTypes[i][i2].id === currentValues?.fieldModule) {
            //             _targetType = fieldTypes[i][i2].target
            //         }
            //     })
            // })

            let data = {
                injection_fields: [{
                    field_module: currentValues?.fieldModule,
                    field_ref: currentValues?.fieldRef,
                    field_key: currentValues?.fieldKey,
                    field_type: currentValues?.fieldType,
                }]
            }

            console.log('data', data)

            const response = await create({ data, targetType: _targetType });

            promptMessage(true, `${response?.message}`)
            navigate(getRoute("settings/injectionFields"))

        } catch (error) {
            promptMessage(false, `Action Failed. (${error?.message})`)
        }

    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, setFieldValue } = formik;

    const RenderForm = () => {

        // get the list options for props module
        let fieldModuleLists = []

        if (values?.fieldRef) {
            Object.keys(moduleTypes[values.fieldRef]).forEach(i => {
                fieldModuleLists.push({
                    ...moduleTypes[values.fieldRef][i],
                    name: i
                })
            })
        }

        return (

            <form onSubmit={formik.handleSubmit}>
                <StyledCard>
                    <Grid container spacing={0.5}>
                        <Grid item xs={12} sm={12} md={4} textAlign={"left"}>

                            <CommonSectionHeader
                                title={t('properties')}
                                subTitle={t('detailOfTheInjectionFields')}
                            />

                        </Grid>
                        <Grid item xs={12} sm={12} md={8}>
                            <Grid item xs={12} md={12} textAlign="left">
                                <Grid container spacing={1}>

                                    <Grid item xs={12} sm={12} md={6}>
                                        {/* <FormGroup> */}
                                        <FormControlLabel disabled checked control={<Checkbox />} label={t('singleValue')} />
                                        {/* </FormGroup> */}
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={6}><></></Grid>

                                    <Grid item xs={12} sm={12} md={6}>
                                        <FormControl
                                            margin="dense"
                                            fullWidth
                                            size="small"
                                            error={Boolean(errors?.fieldRef)}
                                        >
                                            <InputLabel id="fieldRef">{t('moduleReference')}</InputLabel>
                                            <Select
                                                size="small"
                                                label={t("moduleReference")}
                                                name={`fieldRef`}
                                                // handleChange={handleChange}
                                                onChange={(e) => {
                                                    setFieldValue(`fieldRef`, e.target.value)
                                                    setFieldValue(`fieldModule`, '')
                                                }}
                                                value={values?.fieldRef}
                                            // renderValue={(e) => capitalizeString({ val: e })}
                                            >
                                                {
                                                    Object.keys(moduleReferences).map((i, index) => {
                                                        return (
                                                            <MenuItem
                                                                key={index}
                                                                value={i}
                                                            >
                                                                {i}
                                                                {/* <ListItemText primary={`${capitalizeString({ val: i.display })}`} /> */}
                                                            </MenuItem>
                                                        )
                                                    })
                                                }
                                            </Select>
                                            <FormHelperText>
                                                {errors?.fieldRef}
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={6}>
                                        <FormControl
                                            margin="dense"
                                            fullWidth
                                            size="small"
                                            error={Boolean(errors?.fieldModule)}
                                        >
                                            <InputLabel id="module">{t('moduleType')}</InputLabel>
                                            <Select
                                                size="small"
                                                label={t("moduleType")}
                                                name={`fieldModule`}
                                                onChange={(e) => {
                                                    setFieldValue(`fieldModule`, e.target.value)
                                                }}
                                                value={values?.fieldModule}
                                            // renderValue={(e) => capitalizeString({ val: e })}
                                            >
                                                {
                                                    fieldModuleLists.map((i, index) => {
                                                        return (
                                                            <MenuItem
                                                                key={index}
                                                                value={i?.id}
                                                            >
                                                                {i?.id}
                                                                {/* <ListItemText primary={`${capitalizeString({ val: i.display })}`} /> */}
                                                            </MenuItem>
                                                        )
                                                    })
                                                }
                                            </Select>
                                            <FormHelperText>
                                                {errors?.fieldModule}
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={6}>
                                        <FormControl
                                            margin="dense"
                                            fullWidth
                                            size="small"
                                            error={Boolean(errors?.propsField)}
                                        >
                                            <InputLabel id="module">{t('fieldType')}</InputLabel>
                                            <Select
                                                size="small"
                                                label={t("fieldType")}
                                                name={`fieldType`}
                                                onChange={(e) => {
                                                    setFieldValue(`fieldType`, e.target.value)
                                                }}
                                                value={values?.fieldType}
                                            // renderValue={(e) => capitalizeString({ val: e })}
                                            >
                                                {
                                                    Object.keys(fieldDataTypes).map((i, index) => {
                                                        return (
                                                            <MenuItem
                                                                key={index}
                                                                value={fieldDataTypes[i]?.id}
                                                            >
                                                                {fieldDataTypes[i]?.id}
                                                                {/* <ListItemText primary={`${capitalizeString({ val: i.display })}`} /> */}
                                                            </MenuItem>
                                                        )
                                                    })
                                                }
                                            </Select>
                                            <FormHelperText>
                                                {errors?.fieldType}
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={6}>
                                        <TextField
                                            margin="dense"
                                            size="small"
                                            autoFocus
                                            fullWidth
                                            name={`fieldKey`}
                                            label={t("fieldKey")}
                                            type="text"
                                            variant="outlined"
                                            value={values?.fieldKey}
                                            onChange={handleChange}
                                            error={Boolean(errors?.fieldKey)}
                                            helperText={(errors?.fieldKey)}
                                        />
                                    </Grid>

                                </Grid>
                            </Grid>

                        </Grid>

                    </Grid>
                </StyledCard>

                <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"right"}>
                        <Button
                            type="submit"
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2
                            }}
                        >
                            {t('saveChanges')}
                        </Button>
                    </Grid>
                </Grid>
            </form>

        )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.newInjectionField })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("newInjectionField")}
                breadcrumbs={[
                    {
                        displayText: t("injectionFields"),
                        props: {
                            href: getRoute("settings/injectionFields")
                        }
                    },
                    {
                        displayText: t("newInjectionField"),
                        props: {
                            color: 'secondary.main'
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageNew.id }) ?
                    RenderForm()
                    :
                    <CommonRestricted />
            }

        </Box>
    )
}